import React from 'react';

export const LexemePageContext = React.createContext();






